<div *ngIf="matchService.match && !loading" class="container fade-in">
  <div class="match-header {{colorScheme.main}}" *ngIf="matchService.teams">
    <div class="match-toolbar">
      <!-- Back navigation button -->
      <lib-back-button></lib-back-button>
      <!-- Share button -->
      <button
        mat-icon-button
        [class.open]="menuOpen"
        (click)="toggleMenu()">
        <mat-icon>ios_share</mat-icon>
        <div *ngIf="menuOpen" class="match-menu">
          <button (click)="onCopyTickerLink()">
            <mat-icon>content_copy</mat-icon>
            Link zum Spiel kopieren
          </button>
        </div>
      </button>
    </div>
    <!-- Video header -->
    <lib-match-video-header
      *ngIf="videoHeaderContent"
      [content]="videoHeaderContent">
    </lib-match-video-header>

    <div class="match-info">
      <a [href]="homeTeamLink" class="match-info-team">
        <img
          [src]="matchService.teams.home.pictures | imageUrlBySubtype"
          alt="Team Logo"
        />
        <span>{{ matchService.teams.home.name }}</span>
      </a>
      <div class="match-info-details">
        <!-- Pre-game or Auto Mode -->
        <ng-container *ngIf="matchService.match.isInAutoMode() || matchService.match.isPreGame()">
          <span class="date">{{ matchDate | date : 'dd.MM.yyyy' }}</span>
          <span class="time">{{ matchDate | date : 'HH:mm' }}</span>
        </ng-container>

        <!-- Active Match -->
        <ng-container *ngIf="matchService.match.isActive()">
            <span class="status" *ngIf="!matchService.match.isPenalty()">
              <div class="live-indicator"></div>
              {{ matchService.currentMinute }}
            </span>
          <span class="status" *ngIf="matchService.match.isPenalty()">
              <div class="live-indicator"></div>
            {{ matchService.getStatusString() }}
            </span>
          <span class="score">
              {{ matchService.scores.home }} : {{ matchService.scores.away }}
            </span>
          <span class="score-small" *ngIf="matchService.showRegularScore()">
              ({{ matchService.getRegularScore() }})
            </span>
        </ng-container>

        <!-- Cancelled Match -->
        <ng-container *ngIf="matchService.match.isCancelled()">
            <span class="status">
              {{ matchService.getStatusString() }}
            </span>
          <span class="date">{{ matchDate | date : 'dd.MM.yyyy' }}</span>
        </ng-container>

        <!-- Post Game -->
        <ng-container *ngIf="matchService.match.isPostGame()">
          <span class="status" *ngIf="matchService.match.hasPenalty()">Elfmeter</span>
          <span class="status" *ngIf="matchService.match.hasOvertime()">Nach VL</span>
          <span class="status" *ngIf="!matchService.showRegularScore()">Endstand</span>
          <span class="score">
              {{ matchService.scores.home }} : {{ matchService.scores.away }}
            </span>
          <span class="score-small" *ngIf="matchService.showRegularScore()">
              ({{ matchService.getRegularScore() }})
            </span>
        </ng-container>

        <!-- Ended Match -->
        <ng-container *ngIf="matchService.match.isEnded()">
            <span class="date">
              {{ matchDate | date : 'dd.MM.yyyy' }}
            </span>
          <span class="score">
              {{ matchService.scores.home }} : {{ matchService.scores.away }}
            </span>
        </ng-container>
      </div>

      <a class="match-info-team" [href]="awayTeamLink">
        <img
          [src]="matchService.teams.away.pictures | imageUrlBySubtype"
          alt="Team Logo"
        />
        <span>{{ matchService.teams.away.name }}</span>
      </a>
    </div>
    <!-- Goals Container -->
    <div class="ticker-item-container" *ngIf="showGoals">
      <div class="ticker-item-column home">
        <span *ngFor="let goal of getGoalHeaderItems(true)">
          {{ goal.playerName }} {{ goal.minute }}
          {{ goal.type === TickerItemType.PenaltyGoal ? '(11M)' : '' }}
          {{ goal.type === TickerItemType.OwnGoal ? '(ET)' : '' }}
        </span>
      </div>
      <mat-icon>sports_soccer</mat-icon>
      <div class="ticker-item-column away">
        <span *ngFor="let goal of getGoalHeaderItems(false)">
          {{ goal.playerName }} {{ goal.minute }}
          {{ goal.type === TickerItemType.PenaltyGoal ? '(11M)' : '' }}
          {{ goal.type === TickerItemType.OwnGoal ? '(ET)' : '' }}
        </span>
      </div>
    </div>

    <!-- Red Cards Container -->
    <div class="ticker-item-container red-card" *ngIf="showRedCards">
      <div class="ticker-item-column home">
        <span *ngFor="let card of getRedCardHeaderItems(true)">
          {{ card.playerName }} {{ card.minute }}
        </span>
      </div>
      <div class="red-card-icon"></div>
      <div class="ticker-item-column away">
        <span *ngFor="let card of getRedCardHeaderItems(false)">
          {{ card.playerName }} {{ card.minute }}
        </span>
      </div>
    </div>

    <nav #navElement class="match-nav">
      <ng-container *ngFor="let tab of matchService.tabs">
        <a
          *ngIf="tab.active"
          mat-button
          class="tab rise-on-hover-light"
          [routerLink]="tab.path"
          routerLinkActive="active"
          (click)="onNavClicked(tab.path)"
        >
          {{ tab.name }}
        </a>
      </ng-container>
    </nav>
  </div>

  <div class="match-outlet" *ngIf="!this.matchService.loading">
    <lib-ad-sponsor-banner
      [lightHeading]="true"
      [useDomain]="true"
      [entityId]="matchService.match._id"
      [entityType]="entityType"
    >
    </lib-ad-sponsor-banner>
    <router-outlet></router-outlet>
  </div>
</div>
<mat-spinner
  *ngIf="loading"
  class="loading-spinner"
  color="primary"
  diameter="54"
  strokeWidth="2"
></mat-spinner>
